import { MAX_SLIDES_TO_SHOW } from './constants';

export const calculateBreakpoints = (customSettings, tilesLength, showSkipButton) => {
    const { sliderBreakpoints } = customSettings;

    // If the tiles length is less than MAX_SLIDES_TO_SHOW (7) tiles.
    if (tilesLength < MAX_SLIDES_TO_SHOW) {
        sliderBreakpoints[0].slides = tilesLength;
        sliderBreakpoints[1].slides = tilesLength > 4 ? tilesLength - 1 : tilesLength;
        sliderBreakpoints[2].slides = tilesLength < 4 ? tilesLength : 4;
        sliderBreakpoints[3].slides = tilesLength < 3 ? tilesLength : 3;
        sliderBreakpoints[4].slides = tilesLength < 2 ? tilesLength : 2;
        customSettings.slidesToShow = tilesLength;
        customSettings.slidesToScroll= tilesLength;
    }

    // If the tiles length is more than MAX_SLIDES_TO_SHOW (7) tiles.
    else {
        const maxSlides = showSkipButton ? MAX_SLIDES_TO_SHOW - 1 : MAX_SLIDES_TO_SHOW;

        sliderBreakpoints.forEach((breakPoint, index) => {
            breakPoint.slides = maxSlides - index;
        });

        customSettings.slidesToShow = maxSlides;
        customSettings.slidesToScroll= maxSlides;
    }

    // Matching the slides to scroll to the tiles length on each breakpoint.
    sliderBreakpoints.forEach((breakPoint) => {
        breakPoint.slidesToScroll = breakPoint.slides;
    });

    return customSettings;
};
